const GET_CURRICULUM = `query GetCurriculum($lessonPlanIds: [String!]!) {
    getCurriculumInfoForLessons(lessonIds: $lessonPlanIds) {
      schoolYear
      lessonSequence
      lessonName
      lessonId
      lessonDurationType
      lessonDuration
      lessonDisplayName
      lessonDescription
      lessonDateTo
      lessonDateFrom
      grade
      curriculumLessonPlanName
      curriculumLessonPlanId
      curriculumLessonPlanDisplayName
      curriculumLessonPlanDescription
      curriculumId
      unitName
      unitId
      unitDisplayName
      unitDescription
      trackName
      trackId
      trackDisplayName
      trackDescription
      skills {
        skillName
        skillId
        sequence
        locale
        lessonId
        id
        grade
        displayName
        skillType
        windowPeriod
        localeId
      }
    }
  }`;

export default GET_CURRICULUM;
